import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { EyeLubricationAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-eye-lubrication-slot',
    templateUrl: './eye-lubrication-slot.component.html',
    styleUrl: './eye-lubrication-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeLubricationSlotComponent implements SheetSlotComponentBase {

	@Input() action!: EyeLubricationAction;
	value = null;

	constructor() {
	}
}